import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex w-full flex-1 flex-col items-center justify-center space-y-10" }
const _hoisted_2 = ["href"]
const _hoisted_3 = { class: "!mt-10 flex flex-col items-center space-y-10" }
const _hoisted_4 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Slideout"], {
    name: "navigation",
    show: $setup.appStore.navigation.slideout.visible && $setup.showNavigation,
    "show-close": true,
    inverse: true,
    onClose: _cache[0] || (_cache[0] = ($event: any) => ($setup.appStore.navigation.slideout.visible = false))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.centerLinks, (page) => {
          return (_openBlock(), _createElementBlock("a", {
            class: _normalizeClass([page.class === 'a-default' ? ' text-white text-2xl uppercase font-semibold' : page.class]),
            href: page.url
          }, _toDisplayString(page.title), 11 /* TEXT, CLASS, PROPS */, _hoisted_2))
        }), 256 /* UNKEYED_FRAGMENT */)),
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.rightLinks, (page) => {
            return (_openBlock(), _createElementBlock("a", {
              class: _normalizeClass([page.class === 'a-default' ? 'text-white text-2xl uppercase font-semibold' : page.class]),
              href: page.url
            }, _toDisplayString(page.title), 11 /* TEXT, CLASS, PROPS */, _hoisted_4))
          }), 256 /* UNKEYED_FRAGMENT */))
        ])
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["show"]))
}